var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99987 12.4856C10.0296 12.4856 12.4856 10.0296 12.4856 6.99987C12.4856 3.9702 10.0296 1.51416 6.99987 1.51416C3.9702 1.51416 1.51416 3.9702 1.51416 6.99987C1.51416 10.0296 3.9702 12.4856 6.99987 12.4856ZM6.11332 5.14357C5.84553 4.87578 5.41136 4.87578 5.14357 5.14357C4.87578 5.41136 4.87578 5.84553 5.14357 6.11332L6.03013 6.99987L5.14357 7.88643C4.87578 8.15422 4.87578 8.58839 5.14357 8.85618C5.41136 9.12396 5.84553 9.12396 6.11332 8.85618L6.99987 7.96962L7.88643 8.85618C8.15422 9.12396 8.58839 9.12396 8.85618 8.85618C9.12396 8.58839 9.12396 8.15422 8.85618 7.88643L7.96962 6.99987L8.85618 6.11332C9.12396 5.84553 9.12396 5.41136 8.85618 5.14357C8.58839 4.87578 8.15422 4.87578 7.88643 5.14357L6.99987 6.03013L6.11332 5.14357Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.51216a954d2a776dc785479ff1a1d882.svg";
export { ForwardRef as ReactComponent };